module.exports = __webpack_public_path__ + "img/Trophy.5ba13c27.svg";